module.exports = __webpack_public_path__ + "static/media/closeCookie.69e5ba19.svg";